import eventService from "@/api/eventModule/eventServices";

export default {
  loadTable({ commit }, pageConfig) {
    return new Promise((resolve, reject) =>
      eventService
        .loadTable(pageConfig)
        .then((result) => {
          commit("LOAD_LIST_EVENT", result.data.content);
          resolve(result);
        })
        .catch((err) => reject(err))
    );
  },
  insertNewEvent({ commit }, data) {
    return eventService
      .insertNewEvent(data)
      .then((result) => result)
      .catch((error) => error);
  },
  prepareToEditEvent({ commit }, data) {
    commit("PREPARE_TO_EDIT_EVENT", data);
  },
  editEvent({ commit }, data) {
    return eventService
      .editEvent(data)
      .then((result) => result)
      .catch((error) => error);
  },
  resetEvent({ commit }) {
    commit("RESET_EVENT");
  },
  delete({ commit }, id) {
    return eventService
      .deleteEvent(id)
      .then((result) => result)
      .catch((error) => error);
  },
};
